// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { select, Store } from '@ngrx/store';
import { selectLanguage } from '@med/app/core/language/store';
import { filter } from 'rxjs/operators';
import { ConfigService } from '@med/app/core/config/config.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageInterceptor implements HttpInterceptor {

  private language: string;

  constructor(
    private store: Store,
    private configService: ConfigService,
  ) {
    this.store.pipe(
      select(selectLanguage),
      filter(language => !!language),
    ).subscribe(language => this.language = language);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.includes(this.configService.getConfig().apiUrl) || !this.language || new RegExp(this.configService.getConfig().excludedLanguageUrlRegex).test(req.url)) {
      return next.handle(req);
    }

    const requestClone = req.clone({headers: req.headers.set('Content-Language', `${ this.language }`)});

    return next.handle(requestClone);
  }
}
